import { FC, ReactNode } from 'react'
import { Box, makeStyles } from '@perk-ui/core'

const useStyles = makeStyles((theme) => ({
  formContainer: {
    '& form': {
      width: '100%',
      '& .MuiFormControl-root': { marginBottom: theme.spacing(1.5) },
      '& .MuiInput-root': { overflow: 'hidden' },
      '& .MuiButton-root': {
        marginBottom: theme.spacing(3),
        borderRadius: '16px',
      },
      '& .MuiLink-root': {
        textDecoration: 'none',
        fontWeight: 700,
        '&:visited': { color: theme.palette.primary.main },
        '&:hover': {
          color: theme.palette.primary.dark,
          textDecoration: 'underline',
        },
      },
      '& .MuiAlert-root': {
        marginBottom: theme.spacing(2),
        '&.MuiAlert-standardSuccess': {
          color: theme.palette.success.dark,
          '& .MuiAlert-icon': { color: theme.palette.success.dark },
        },
      },
      '& .form-checkbox-control-label': { margin: 0 },
    },
  },
}))

interface FormContainerProps {
  children: ReactNode
  className?: string
}

const FormContainer: FC<FormContainerProps> = ({
  children,
  className = '',
}) => {
  const classes = useStyles()

  return (
    <Box className={`${classes.formContainer} ${className}`}>{children}</Box>
  )
}

export default FormContainer
